/**
 * @generated SignedSource<<cd9b33988e01cc1a8280231c11368da2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTicketingProfileInput = {
  emailSignature?: string | null;
  replyToEmail?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateTicketingProfileMutation$variables = {
  input: UpdateTicketingProfileInput;
};
export type useUpdateTicketingProfileMutation$data = {
  readonly updateTicketingProfile: {
    readonly clientMutationId: string | null;
    readonly user: {
      readonly id: string;
      readonly emailSignature: string | null;
    } | null;
  } | null;
};
export type useUpdateTicketingProfileMutation = {
  variables: useUpdateTicketingProfileMutation$variables;
  response: useUpdateTicketingProfileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTicketingProfilePayload",
    "kind": "LinkedField",
    "name": "updateTicketingProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailSignature",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateTicketingProfileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateTicketingProfileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fcb2975df42072ff68f973afa6c77650",
    "id": null,
    "metadata": {},
    "name": "useUpdateTicketingProfileMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateTicketingProfileMutation(\n  $input: UpdateTicketingProfileInput!\n) {\n  updateTicketingProfile(input: $input) {\n    clientMutationId\n    user {\n      id\n      emailSignature\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e99242ba05118d6085890962a3a5aa4";

export default node;
